/*
* @Author: 王春岩 <Bolt>
* @Date:   2016-12-21 18:14:56
 * @Last Modified by: 刘旭（DK）
 * @Last Modified time: 2018-10-25 15:52:42
*/

'use strict';

import '../util/common.js';

import '../modules/article/amy-or-betty.js';
import '../modules/editor/index.js';
import '../modules/focus.empty/index.js';
import '../modules/footer/index.js';
import '../modules/header.empty/index.js';
import '../modules/helpfind/index.js';
import '../modules/image/index.js';
import '../modules/newcar/index.js';
import '../modules/recommend/index.js';
import '../modules/sellcar/index.js';
// import '../modules/tangeche/index.js';
import '../modules/toolbar/index.js';

import './index.js';



// WEBPACK FOOTER //
// ./src/pages/template_betty.js